import axios from 'axios'
import platform from 'platform'
//###################################################axios封装 ###############################################
/*
创建axios对象
 */
const service = axios.create({
  timeout: 30000,
  headers: {
    PlatForm: platform.os + '$' + platform.name + '$' + platform.version,
    EquipmentNo: 'web'
  }
})
/*
允许用户操作系统的作用时长
 */
const operateTime = 30 * 60 * 1000
/**
 * 需要放行的路径
 */
const urlArr = ['/login','/open/app/common/login','/open/app/identity/authentication']

/**
 * 请求拦截器
 */
service.interceptors.request.use(
  config => {
    if (!sessionStorage.time) {
      sessionStorage.time = new Date().getTime()
    }
    const delayTime = new Date().getTime() - sessionStorage.time
    if (urlArr.indexOf(config.url) === -1) {
      if (delayTime > operateTime) {
        //用户操作时间过期，清除session
        sessionStorage.clear()
        window.location.href = '/'
      }
      if (!sessionStorage.user_info || !sessionStorage.token) {
        //清除session
        sessionStorage.clear()
        window.location.href = '/'
      }
      sessionStorage.time = new Date().getTime();
    }
    config.headers['Authorization'] = sessionStorage.token
    return config;
  },
  error => {
    Promise.reject(error)
  }
)
/*
* 响应拦截器
 */
service.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/axios/index.js